import { Avatar } from '#src/components/avatar/Avatar/index.tsx';
import { CLUB_PLACEHOLDER } from '#src/constants/assets.ts';

type Props = {
  club: {
    name?: string;
    avatarUrl?: string | null;
  };
  withTooltip?: boolean;
  className?: string;
  size?: number;
};

export const DumbClubAvatar = ({ club, ...rest }: Props) => {
  return <Avatar {...club} {...rest} fallbackUrl={CLUB_PLACEHOLDER} />;
};
